import { Component } from '@angular/core';
import { ChartKvaroviComponent } from 'src/app/RadniNalozi/chart-kvarovi/chart-kvarovi.component';
import { ChartServiseriComponent } from 'src/app/RadniNalozi/chart-serviseri/chart-serviseri.component';

@Component({
  selector: 'app-radni-nalozi-report',
  standalone: false,
  templateUrl: './radni-nalozi-report.component.html',
  styleUrl: './radni-nalozi-report.component.css'
})
export class RadniNaloziReportComponent {

}
